import { Link } from 'react-router-dom';
import type { Drama } from '@/types/drama';
import DramaCard from '@/components/feature/DramaCard';

interface DramaGridSectionProps {
  title: string;
  subtitle: string;
  items: Drama[];
  moreLink?: string;
}

export default function DramaGridSection({ title, subtitle, items, moreLink }: DramaGridSectionProps) {
  return (
    <section className="w-full px-4 md:px-16 lg:px-24 py-12 md:py-16">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 mb-6 md:mb-8">
        <div>
          <div className="flex items-center gap-2 mb-2">
            <span className="w-1 h-5 rounded-full bg-accent-500" />
            <span className="text-xs font-medium text-foreground-500 tracking-wide">精选推荐</span>
          </div>
          <h2 className="font-heading font-bold text-foreground-950 text-2xl md:text-3xl">{title}</h2>
          <p className="text-foreground-600 text-sm mt-2">{subtitle}</p>
        </div>
        {moreLink && (
          <Link
            to={moreLink}
            className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 hover:text-primary-800 transition-colors"
          >
            查看全部
            <i className="ri-arrow-right-line" />
          </Link>
        )}
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-5">
        {items.map((drama) => (
          <DramaCard key={drama.id} drama={drama} />
        ))}
      </div>
    </section>
  );
}